import(/* webpackMode: "eager" */ "/app/src/app/[lang]/auth/forgot-password/page.tsx");
